export const cleanPhoneNumber = (phoneNumber: string): string => {
  if (!phoneNumber) return '';
  return phoneNumber.replace(/\D/g, '');
};

// Function to check if a string is a valid phone number
export const isValidPhoneNumber = (phoneNumber: string): boolean => {
  if (!phoneNumber) return false;
  const cleaned = cleanPhoneNumber(phoneNumber);
  // Check if it's a valid length (adjust min/max as needed for your requirements)
  return cleaned.length >= 10 && cleaned.length <= 15;
};

export const formatPhoneForDisplay = (phoneNumber: string): string => {
  const cleaned = cleanPhoneNumber(phoneNumber);

  // Format as (XX) XXXXX-XXXX for Brazilian numbers
  if (cleaned.length === 11) {
    return `(${cleaned.substring(0, 2)}) ${cleaned.substring(
      2,
      7
    )}-${cleaned.substring(7)}`;
  }

  if (cleaned.length === 10) {
    return `(${cleaned.substring(0, 2)}) ${cleaned.substring(
      2,
      6
    )}-${cleaned.substring(6)}`;
  }

  // Return as is if not matching standard formats
  return phoneNumber;
};
